// Company and user management components
import { defineAsyncComponent } from 'vue'

export default {
  CompanyForm: defineAsyncComponent(() => import('../company_form.vue')),
  CompanyOwners: defineAsyncComponent(() => import('../company_owners.vue')),
  CompanyTable: defineAsyncComponent(() => import('../company_table.vue')),
  SupplierRolesForm: defineAsyncComponent(
    () => import('../supplier_roles_form.vue')
  ),
  UnifiedUserForm: defineAsyncComponent(
    () => import('../unified_user_form.vue')
  )
}
